
import './App.css';
import TicTacToe from './Components/TicTacToe';
import React, { Component }  from 'react';
function App() {
  return (
    <div className="App">
     <TicTacToe/>
    </div>
  );
}

export default App;
